
import { EVENT_SOURCE } from '~~/constants/googleTagManager';

import type { EventSourceLocation } from '~~/types/integrations/tagManager/TagManagerIntegration';

export default function (): { getCurrentPageType: () => EventSourceLocation } {

  const { isOnProductPage, isOnHomePage, isCheckoutPage, isOnSearchPage, isOnInternalCmsPage } = useIsPage();
  const { isOnCategory } = useIsOnCategory();

  const getCurrentPageType = (): EventSourceLocation => {

    let pageType: EventSourceLocation;
    const isCategory = isOnCategory();

    if (isOnSearchPage.value) {

      pageType = EVENT_SOURCE.SEARCH_LISTING;
    
    } else if (isOnHomePage.value) {

      pageType = EVENT_SOURCE.HOMEPAGE;
    
    } else if (isOnProductPage.value) {

      pageType = EVENT_SOURCE.PDP;
    
    } else if (isCheckoutPage.value) {

      pageType = EVENT_SOURCE.CHECKOUT;
    
    } else if (isCategory) {

      pageType = EVENT_SOURCE.CATEGORY_LISTING;
    
    } else if (isOnInternalCmsPage.value) {

      pageType = EVENT_SOURCE.LANDING_PAGE;
    
    }

    return pageType;
  
  };

  return { getCurrentPageType };

}
